import { Component, OnInit, OnDestroy, ViewChild, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CommonMethodService } from '../../common/commonMethod.service';
import { UserGroupService } from '../../services/userGroup.service';
import { DataShareService } from '../../services/data-share.service';
import { AccountService } from '../../services/account.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { EmployeeService } from '../../services/employee.service';
import { ToastrService } from 'ngx-toastr';
import { ResidentService } from '../../services/resident.service';
import { NotificationService } from '../../services/notification.service';
import { AdministratorService } from '../../services/administrator.service';
import { UserService } from '../../services/user.service';
import { LoginService } from '../../services/login.service';
import { InactivityTimeoutService } from '../../common/inactivity-timeout.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  providers: [CommonMethodService, UserGroupService, DataShareService, AccountService, EmployeeService, ResidentService, NotificationService, AdministratorService, UserService, LoginService]
})
export class DefaultLayoutComponent implements OnInit, OnDestroy {
  @ViewChild('primaryModal') public primaryModal: ModalDirective;
  @ViewChild('primaryModal1') public primaryModal1: ModalDirective;
  public sidebarMinimized = false;
  public navItems = [];
  public navItemsRaw = [];
  public list = [];
  role: any;
  accountId: any;
  accountName: string;
  subscribe: Array<Subscription> = [];
  imageName: any;
  username: any;
  roleShow: string;
  qrCodeName: any;
  employeeId: any;
  residentId: any;
  name: string;
  isExpired: boolean = false;
  expTime: string = '';
  type: string;
  propertyInfo: any = {};
   panicNotificationCount: any;
   userMasterId: any;
    manufacturingAccountFeature: boolean = false;
    selfCheckInFeature: boolean = false;
    emailNotificationFeature: boolean = false;
    userImage: any;
   bindingEligible: boolean = false;
   licenseStatus: string;
   featureEnabled: boolean = false;

  // imageName: "assets/compas-logo.png"


  constructor(private httpClient: HttpClient, private route: Router, private commonMethodService: CommonMethodService,
    private userGroupService: UserGroupService, private dataShareService: DataShareService, private accountService: AccountService,
    private employeeService: EmployeeService, private toaster: ToastrService, private residentService: ResidentService, private notificationService: NotificationService, private administratorService: AdministratorService, private userService: UserService,
    private loginService: LoginService, private inactivityTimeout: InactivityTimeoutService) {
  }

  toggleMinimize(e) {
    this.sidebarMinimized = e;
  }

  logout(): void {
    this.loginService.logout().subscribe({
      complete: () => {
        sessionStorage.clear();
        this.route.navigate(['/']);
      },
      error: () => {
        sessionStorage.clear();
        this.route.navigate(['/']);
      },
    });
    this.inactivityTimeout.stop();
  }

  changePassword(): void {
    this.route.navigate(['/home/adminstrator/change-password']);
  }

  ngOnInit() {
    this.inactivityTimeout.start();
    
    const token = sessionStorage.getItem('token');
    const username = sessionStorage.getItem('username');
    const role = sessionStorage.getItem('role');
    const accountId = sessionStorage.getItem('accountId');
    
    if (!token || !username || !role || 
        token === 'undefined' || token === 'null' ||
        username === 'undefined' || username === 'null' ||
        role === 'undefined' || role === 'null') {
      this.route.navigate(['/login']);
      return;
    }

    if (role !== 'SUPER_ADMIN' && (!accountId || accountId === 'undefined' || accountId === 'null')) {
      this.route.navigate(['/login']);
      return;
    }
    
    this.role = sessionStorage.getItem('role');
    this.type = sessionStorage.getItem('type');
    if (this.role === 'SUPER_ADMIN') {
      this.roleShow = 'SUPER_OWNER';
    } else if (this.role === 'ACCOUNT_ADMIN') {
      this.roleShow = 'ACCOUNT_SUPER_ADMIN';
    } else {
      this.roleShow = this.role;
    }
    this.accountName = sessionStorage.getItem('accountName');
    this.employeeId = sessionStorage.getItem('employeeId');
    this.accountId = sessionStorage.getItem('accountId');
    this.username = sessionStorage.getItem('username');
    this.residentId = sessionStorage.getItem('residentId');
    this.userMasterId = sessionStorage.getItem('userMasterId');
    this.bindingEligible = sessionStorage.getItem('bindingEligible') === 'true';
    this.licenseStatus = sessionStorage.getItem('licenseStatus') || 'VALID';
    this.loadUserImage();
    if (this.role !== 'SUPER_ADMIN') {
      this.getAccountConfiguration();
    }
    if (this.role === 'SUPER_ADMIN' || this.role === 'RESIDENT_ADMIN' || this.role === 'EMPLOYEE_ADMIN' || this.role === 'FAMILY') {

      this.httpClient.get('assets/roleModel/superadmin.json').subscribe(data => {
        this.list = JSON.parse(JSON.stringify(data));
        this.list.forEach(x => {
          if (x.role === this.role) {
            if (this.role === 'SUPER_ADMIN' && this.username !== 'superowner') {
              x.allowActions.forEach((item) => {
                if (item.children !== undefined) {
                  item.children.forEach((subItem, index) => {
                    if (subItem.name === 'Superowner Request Details') {
                      return item.children.splice(index, 1);
                    }
                  });
                }
              });
              this.navItems = x.allowActions;
              this.navItemsRaw = JSON.parse(JSON.stringify(x.allowActions));
            } else {
              this.navItems = x.allowActions;
              this.navItemsRaw = JSON.parse(JSON.stringify(x.allowActions));
            }
          }
        });
        this.applyAllFeatureFilters();
        // console.log(data);
      });
      this.loadBindingFeatureFlag();
    } else if (this.role === 'DEVICE_ADMIN') {
      if (this.type === 'RESIDENTIAL') {
        this.httpClient.get('assets/roleModel/superadmin.json').subscribe(data => {
          this.list = JSON.parse(JSON.stringify(data));
          this.list.forEach(x => {
            if (x.role === 'DEVICE_ADMIN_R') {
              this.navItems = x.allowActions;
              this.navItemsRaw = JSON.parse(JSON.stringify(x.allowActions));
            }
          });
          this.applyAllFeatureFilters();
        });
      } else {
        this.httpClient.get('assets/roleModel/superadmin.json').subscribe(data => {
          this.list = JSON.parse(JSON.stringify(data));
          this.list.forEach(x => {
            if (x.role === 'DEVICE_ADMIN_C') {
              let items = x.allowActions;
              if (this.manufacturingAccountFeature) {
                items = items.filter(e => e.name != 'Service Provider');
              } else {
                items = items.filter(e => e.name != 'Contractor' && e.name != 'Vehicle Management');
              }
              this.navItems = items;
              this.navItemsRaw = JSON.parse(JSON.stringify(items));
            }
          });
          this.applyAllFeatureFilters();
        });
      }
      this.loadBindingFeatureFlag();
    } else {
      const username = sessionStorage.getItem('username');
      if (!username) {
        if (this.route) {
          this.route.navigate(['/login']);
        }
        return;
      }
      this.subscribe.push(this.userGroupService.getUsersRights(username).subscribe(
        data => {
          const wrapper = JSON.parse(JSON.stringify(data));
          this.navItems = wrapper[0].allowActions;
          this.navItemsRaw = JSON.parse(JSON.stringify(wrapper[0].allowActions));
          this.dataShareService.setValue(this.navItems);
          this.applyAllFeatureFilters();
        }, error => {
          this.commonMethodService.returnErrorMessage(error);
        }));
      
      this.loadBindingFeatureFlag();
    }
    if (this.accountId !== '' && this.accountId !== undefined && this.accountId !== null) {
      this.getAccountImage('');
    } else {
      this.imageName = 'assets/Icon-196.png';
    }

    // if(this.role==='EMPLOYEE_ADMIN'){
    //   this.checkStaffQRExpire();
    // }
    if (this.role === 'WEB_ADMIN' || this.role === 'ACCOUNT_ADMIN') {
      this.getPanicNotificationCount();
    }
  }
  loadUserImage(): void {
    const userImageName = sessionStorage.getItem('userImage');
    if (userImageName !== undefined && userImageName !== null && userImageName !== '') {
      this.subscribe.push(this.userService.getImageBase64(userImageName).subscribe(
        data => {
          const wrapper = JSON.parse(JSON.stringify(data));
          if (wrapper.imageBase64 !== undefined && wrapper.imageBase64 !== null && wrapper.imageBase64 !== '') {
            this.userImage = 'data:image/jpg;base64,' + wrapper.imageBase64;
          }
        }, error => {
          this.commonMethodService.returnErrorMessage(error);
        }));
    }
  }

   getAccountConfiguration(): void {
    this.subscribe.push(this.administratorService.getAccountConfiguration(this.accountId).subscribe(
      data => {
        const wrapper = JSON.parse(JSON.stringify(data));
        wrapper.forEach(element => {
          if (element.featureId === 10) {
            this.manufacturingAccountFeature = element.value === 'true' ? true : false;
          }
          if (element.featureId === 14) {
            this.selfCheckInFeature = element.value === 'true' ? true : false;
          }
          if (element.featureId === 15) {
            this.emailNotificationFeature = element.value === 'true' ? true : false;
            this.dataShareService.emailNotificationFeature = this.emailNotificationFeature;
          }
        });
        this.applyAllFeatureFilters();
      }, error => {
        this.commonMethodService.returnErrorMessage(error);
      }
    ));
  }
  getAccountImage(value): void {
    this.subscribe.push(this.accountService.findAccountById(this.accountId).subscribe(
      data => {
        const wrapper = JSON.parse(JSON.stringify(data));
        if (wrapper.imageB64 === undefined || wrapper.imageB64 === '' || wrapper.imageB64 === null) {
          this.imageName = 'assets/Icon-196.png';
        } else {
          // const image = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + wrapper.imageName);
          this.imageName = wrapper.imageB64;
        }
        this.propertyInfo = wrapper;
        if (value === 'property') {
          this.primaryModal1.show();
        }
      }, error => {
        this.commonMethodService.returnErrorMessage(error);
      }));

  }

  getPropertyInfo(): void {
    this.getAccountImage('property');
  }

  regenerateQRCode(): void {
    this.subscribe.push(this.employeeService.regenerateQRCode(this.employeeId).subscribe(
      data => {
        this.toaster.success('QR code re-generated successfully');
        this.isExpired = false;
        this.primaryModal.hide();
      }, error => {
        this.commonMethodService.returnErrorMessage(error);
      }));
  }

  regenerateResidentQRCode(): void {
    this.subscribe.push(this.residentService.regenerateQRCode(this.residentId).subscribe(
      data => {
        this.toaster.success('QR code re-generated successfully');
        this.isExpired = false;
        this.primaryModal.hide();
      }, error => {
        this.commonMethodService.returnErrorMessage(error);
      }));
  }

  checkStaffQRExpire(): void {
    this.subscribe.push(this.employeeService.checkStaffQRExpire(this.employeeId, this.accountId).subscribe(
      data => {
        this.isExpired = JSON.parse(JSON.stringify(data));
      }, error => {
        this.commonMethodService.returnErrorMessage(error);
      }));
  }

  checkResidentQRExpire(): void {
    this.subscribe.push(this.residentService.checkResidentQRExpire(this.residentId, this.accountId).subscribe(
      data => {
        this.isExpired = JSON.parse(JSON.stringify(data));
      }, error => {
        this.commonMethodService.returnErrorMessage(error);
      }));
  }

  showStaffQRCode(): void {
    this.expTime = '';
    this.subscribe.push(this.employeeService.getStaffQRImage(this.employeeId).subscribe(
      data => {
        const wrapper = JSON.parse(JSON.stringify(data));
        this.qrCodeName = 'data:image/jpg;base64,' + wrapper.imageBase64;
        this.name = wrapper.name;
        this.expTime = wrapper.qrExpiryDate;
        this.checkStaffQRExpire();
        this.primaryModal.show();
      }, error => {
        this.commonMethodService.returnErrorMessage(error);
      }));
  }

  showResidentQRCode(): void {
    this.expTime = '';
    this.subscribe.push(this.residentService.getResidentQRImage(this.residentId).subscribe(
      data => {
        const wrapper = JSON.parse(JSON.stringify(data));
        this.qrCodeName = 'data:image/jpg;base64,' + wrapper.imageBase64;
        this.name = wrapper.name;
        this.expTime = wrapper.qrExpiryDate;
        this.checkResidentQRExpire();
        this.primaryModal.show();
      }, error => {
        this.commonMethodService.returnErrorMessage(error);
      }));
  }

  //  downloadQRCode(): void {
  //   this.subscribe.push(this.employeeService.getStaffQRImage(this.employeeId).subscribe(
  //     data => {
  //       const wrapper  = JSON.parse(JSON.stringify(data));
  //       if (wrapper.imageBase64 === undefined || wrapper.imageBase64 === '' || wrapper.imageBase64 === null) {
  //         this.toaster.error('No image found!!!');
  //       } else {
  //         var a = document.createElement("a"); //Create <a>
  //         a.href = "data:image/png;base64," + wrapper.imageBase64; //Image Base64 Goes here
  //         a.download = "QRCode.png"; //File name Here
  //         a.click(); //Downloaded file
  //       }
  //     }, error => {
  //       this.commonMethodService.returnErrorMessage(error);
  //     }));
  // }

  // downloadResidentQRCode(): void {
  //   this.subscribe.push(this.residentService.getResidentQRImage(this.residentId).subscribe(
  //     data => {
  //       const wrapper  = JSON.parse(JSON.stringify(data));
  //       if (wrapper.imageBase64 === undefined || wrapper.imageBase64 === '' || wrapper.imageBase64 === null) {
  //         this.toaster.error('No image found!!!');
  //       } else {
  //         var a = document.createElement("a"); //Create <a>
  //         a.href = "data:image/png;base64," + wrapper.imageBase64; //Image Base64 Goes here
  //         a.download = "QRCode.png"; //File name Here
  //         a.click(); //Downloaded file
  //       }
  //     }, error => {
  //       this.commonMethodService.returnErrorMessage(error);
  //     }));
  // }

  downloadQRCode(): void {
    const a = document.createElement('a');
    a.href = this.qrCodeName;
    a.download = 'QRCode.png';
    a.click();
  }

  loadImage(): string {
    return this.imageName;
  }

  ngOnDestroy(): void {
    this.subscribe.forEach(destroyExistingValue => {
      destroyExistingValue.unsubscribe();
    });
  }

  getPanicNotificationCount(): void {
    this.subscribe.push(this.notificationService.getPanicNotificationCount(this.accountId, this.userMasterId).subscribe(
      data => {
        const wrapper = JSON.parse(JSON.stringify(data));
        this.panicNotificationCount = wrapper.panicNotificationCount
      }, error => {
        this.commonMethodService.returnErrorMessage(error);
      }));
  }

  changeStatusPanicNotifiaction(): void {
    this.subscribe.push(this.notificationService.changeStatusPanicNotifiaction(this.accountId, this.userMasterId).subscribe(
      data => {
        const wrapper = JSON.parse(JSON.stringify(data));
        this.panicNotificationCount = wrapper.panicNotificationCount
      }, error => {
        this.commonMethodService.returnErrorMessage(error);
      }));
  }

  private removeBindingItems(navItems: any[], hideBinding: boolean): any[] {
    if (!hideBinding) {
      return navItems;
    }
    const bindingNames = ['Device Binding Management', 'Bind Mobile App'];
    const filterRecursive = (items: any[]): any[] => {
      return items.filter(item => !bindingNames.includes(item.name)).map(item => {
        if (item.children && item.children.length > 0) {
          return { ...item, children: filterRecursive(item.children) };
        }
        return item;
      });
    };
    return filterRecursive(navItems);
  }

  private loadBindingFeatureFlag(): void {
    if (!this.accountId) return;
    this.subscribe.push(this.administratorService.checkMobileBindingLicense(this.accountId).subscribe(
      data => {
        const wrapper: any = data;
        this.featureEnabled = wrapper.featureEnabled || false;
        this.applyAllFeatureFilters();
      },
      error => {
        this.featureEnabled = false;
        this.applyAllFeatureFilters();
      }
    ));
  }

  private applyAllFeatureFilters(): void {
    if (!this.navItemsRaw || this.navItemsRaw.length === 0) {
      return;
    }
    let filtered = JSON.parse(JSON.stringify(this.navItemsRaw));
    if (!this.featureEnabled) {
      filtered = this.removeBindingItems(filtered, true);
    }
    if (!this.selfCheckInFeature) {
      filtered = this.removeSelfCheckInItems(filtered, true);
    }
    this.navItems = filtered;
    this.dataShareService.setValue(this.navItems);
  }

  private removeSelfCheckInItems(navItems: any[], hideSelfCheckIn: boolean): any[] {
    if (!hideSelfCheckIn) {
      return navItems;
    }
    const selfCheckInNames = ['Self Check In QR'];
    const filterRecursive = (items: any[]): any[] => {
      return items.filter(item => !selfCheckInNames.includes(item.name)).map(item => {
        if (item.children && item.children.length > 0) {
          return { ...item, children: filterRecursive(item.children) };
        }
        return item;
      });
    };
    return filterRecursive(navItems);
  }
}
